import { HttpErrorResponse } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ReplaySubject, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ClienteOutput } from "src/app/@shared/models/cliente.model";
import { ClienteService } from "src/app/services/cliente/cliente.service";
import { ComplementoFaturaCteService } from "src/app/services/complemento-fatura-cte/complemento-fatura-cte.service";
import { ComplementoFaturaCteComponent } from "../complemento-fatura-cte.component";
import { ComplementoFaturaCte } from "../complemento-fatura-cte.model";

@Component({
  selector: "app-complemento-fatura-cte-filtro-pesquisa",
  templateUrl: "./complemento-fatura-cte-filtro-pesquisa.component.html",
  styleUrls: ["./complemento-fatura-cte-filtro-pesquisa.component.scss"],
})
export class ComplementoFaturaCteFiltroPesquisaComponent implements OnInit {
  @Input() parent: ComplementoFaturaCteComponent;
  @Input() formPesquisa;
  isLoading: boolean;

  get dataInicio() {
    return this.formPesquisa.get("dataInicio").value;
  }
  get dataFim() {
    return this.formPesquisa.get("dataFim").value;
  }
  get clienteId() {
    return this.formPesquisa.get("clienteId").value;
  }
  get tipoStatus() {
    return this.formPesquisa.get("tipoStatus").value;
  }
  get tipoFatura() {
    return this.formPesquisa.get("tipoFatura").value;
  }

  private onDestroy = new Subject<void>();
  clientes: ClienteOutput[];
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<
    ClienteOutput[]
  >(1);
  public clienteMultiFilter: FormControl = new FormControl();

  tiposStatus = [];
  tiposFatura = [
    { id: "1", descricao: "CT-es com erros" },
    { id: "2", descricao: "CT-es autorizados" },
    { id: "3", descricao: "NFS-es Autorizados" },
  ];
  
  constructor(
    public service: ComplementoFaturaCteService,
    public clienteService: ClienteService
  ) {}

  ngOnInit() {
    this.listarStatus();
    this.listarClientes();
  }

  public async listarStatus() {
    return this.service
      .listarStatusLote()
      .toPromise()
      .then(
        (response: any[]) => {
          this.tiposStatus = response;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.parent.openSnackBar(
            "Erro ao carregar status, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async listarClientes() {
    return this.service
      .listarClientes()
      .toPromise()
      .then(
        (response: ClienteOutput[]) => {
          this.clientes = response.filter(x => x.id == 1769 && 1938);
          this.filteredClientes.next(this.clientes.slice());
          this.clienteMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.clientes,
                this.clienteMultiFilter,
                this.filteredClientes,
                "nome"
              );
            });
          this.formPesquisa.get("clienteId").setValue(1769);
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.parent.openSnackBar(
            "Erro ao carregar clientes!",
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      );
  }

  public clearFields() {
    this.formPesquisa.reset();
    this.formPesquisa.get("clienteId").setValue(1769);
    this.formPesquisa.get("tipoStatus").setValue("");
    this.formPesquisa.get("tipoFatura").setValue("");
    this.parent.arrayAbas = [];
    this.parent.changeTabIndex(0);
    this.parent.exibirGrid = false;
  }

  private filtroGeral(
    filtro: any,
    multifilter: any,
    filtered: any,
    field: string
  ) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(
        (response) => response[field].toLowerCase().indexOf(search) > -1
      )
    );
  }

  getValue(fieldName) {
    return this.formPesquisa?.get(fieldName)?.value;
  }

  trigger() {
    const dataInicio = this.dataInicio ? this.dataInicio.toISOString().split('T')[0] : null;
    const dataFim = this.dataFim ? this.dataFim.toISOString().split('T')[0] : null;
    if (dataFim < dataInicio) {
      this.parent.openSnackBar('Data final não pode ser menor que data inicial.', 'OK', 3000);
      return;
    }
    var filters = {
      dataInicio: this.dataInicio
        ? this.dataInicio.toISOString().split("T")[0]
        : null,
      dataFim: this.dataFim ? this.dataFim.toISOString().split("T")[0] : null,
      clienteId: this.clienteId,
      statusLote: this.tipoStatus.toString(),
      tipoFatura: this.tipoFatura,
      paginaAtual: 1,
    } as ComplementoFaturaCte;
    this.parent.carregarGrid(filters);
  }
}
